/**
* this file contains the array for the topbar & left menu component
*
* Created by Tom on 28/5/17
*/

import config from '../../config'

const menuItems = [

]

export default menuItems



// WEBPACK FOOTER //
// ./src/components/TopBar/menuItems.js